import { __read } from "tslib";
import { OfficeThemeMode } from '@office-start/theming-types';
import { constructCdnUrl } from '@office-start/url-parser-utility';
import React from 'react';
export var FirstRunImage = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, imgConfig = _a.imgConfig, themeMode = _a.themeMode, context = _a.context;
    var _c = __read(React.useState(''), 2), url = _c[0], setUrl = _c[1];
    React.useEffect(function () {
        if (context && themeMode) {
            var cdnUrl = constructThemedCdnUrl(context, themeMode, imgConfig);
            if (cdnUrl) {
                setUrl(cdnUrl);
            }
        }
    }, [context, themeMode, imgConfig]);
    // TODO: if no altText, specify aria label decorator
    var imgElement = React.useMemo(function () {
        return (React.createElement("img", { src: url, alt: imgConfig.altText, className: className, role: imgConfig.altText ? 'img' : 'presentation' }));
    }, [url, imgConfig.altText, className]);
    return imgElement;
};
var constructThemedCdnUrl = function (context, themeMode, imgConfig) {
    var fileName;
    switch (themeMode) {
        case OfficeThemeMode.default:
            fileName = imgConfig.light;
            break;
        case OfficeThemeMode.dark:
            fileName = imgConfig.dark;
            break;
        case OfficeThemeMode.highContrast:
            fileName = imgConfig.highContrast;
            break;
        default:
            var exhaustiveCheck = themeMode;
            throw new Error(exhaustiveCheck);
    }
    var cdnUrl = constructCdnUrl(context === null || context === void 0 ? void 0 : context.cdnDomain, 'officestartresources', fileName, imgConfig.format || 'svg');
    return cdnUrl;
};
//# sourceMappingURL=FirstRunImage.js.map